import React from "react"
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material"
import T from "../hooks/Language/T"

const SkillLevelSelect = ({ value, onChange }) => {
  return (
    <T>
      <FormControl fullWidth>
        <InputLabel id='skill-level-label'>Skill Level</InputLabel>
        <Select
          labelId='skill-level-label'
          id='skill-level-select'
          value={value}
          label='Skill Level'
          onChange={onChange}
        >
          <MenuItem value='beginner'>Beginner</MenuItem>
          <MenuItem value='advanced'>Advanced</MenuItem>
          <MenuItem value='expert'>Expert</MenuItem>
        </Select>
      </FormControl>
    </T>
  )
}

export default SkillLevelSelect
